import { render } from "./GiftCardList.vue?vue&type=template&id=6423a570&scoped=true&ts=true"
import script from "./GiftCardList.vue?vue&type=script&lang=ts"
export * from "./GiftCardList.vue?vue&type=script&lang=ts"

import "./GiftCardList.vue?vue&type=style&index=0&id=6423a570&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6423a570"]])

export default __exports__